module.exports = __webpack_public_path__ + "static/media/Initial_hand_lettered_layout_for_shop_logo_1_2017.647039b7.webp";